import React, { useState } from "react";
import { getUserCredential } from "../../lib/cookies";
import { errStatusHandler, POSTAPI } from "../../api-setup/api-helper";
import { downloadURI, GridColumnDataMapper, ResultGridDataMapper } from "../../utils/utils";
import { USER_GRID_DEFAULT_PAGE_SIZE } from "../../constants/grid";
import { useDispatch } from "react-redux";
import { setNewMessage } from "../../redux/actions/setting-actions";
import {
  GET_SELECT_GRID_COLUMN_XML,
  EXPORT_RESULT_MODULE,
  DELETE_RESULTS,
  SELECT_COMBINED_RESULT_DROPDOWN,
} from "../../api-setup/api-endpoints";
import { useHistory } from "react-router-dom";

let defaultItem = {
  text: USER_GRID_DEFAULT_PAGE_SIZE,
  id: 2,
};

export default function ResultsFilter() {
  const history = useHistory();
  const cookiesData = getUserCredential();
  const header = {
    "x-access-token": cookiesData.secretToken,
  };
  const dispatch = useDispatch();
  const [loading, setLoadingStateSearch] = React.useState({
    isSearchLoader: false,
    isUpdateColumn: false,
  });
  const [columns, setColumns] = React.useState([]);
  const [initialLoading, setLoadingState] = React.useState(false);
  const [isAPICalling, setAPICallingState] = React.useState(false);
  const [resultFilteraliasData, setResultFilteraliasData] = useState([]);
  const [resultFilterData, setResultFilterData] = useState([]);
  const [resultFilterDataCount, setResultFilterDataCount] = useState(0);
  const [resultFilterIsColumnMenuSearch, setResultFilterIsColumnMenuSearch] = useState(false);
  const [resultFilterNoDataFound, setResultFilterNoDataFound] = useState(false);
  const [resultFilterAPICalling, setResultFilterAPICallingState] = useState(false);
  const [resultFilterPaginationData, setResultFilterPaginationData] = useState([]);
  const [resultFilterPageData, setResultFilterPage] = useState(0);
  const [resultFilterPageSize, setResultFilterPageSize] = useState(defaultItem);
  const [resultFilterEditData, setResultFilterEditData] = useState("");
  const [originalFilterData, setResultFilterOriginalData] = useState([]);
  const [resultFilterLoading, setResultFilterLoadingStateSearch] = React.useState({
    isResultSearchLoader: false,
  });
  const [resultFilterLoadingState, setResultFilterLoadingState] = React.useState(false);
  const [confirmationPopup, setConfirmationPopup] = React.useState({
    title: "Delete",
    desc: "Are you sure you want to delete this record?",
    isVisible: false,
    type: "",
    actionBtn: [],
    data: {},
    action: "Delete",
  });
  const [sysConfigTimezone, setSysConfigTimezone] = React.useState("");

  const getColumListXML = (reqData, checked) => {
    POSTAPI(false, GET_SELECT_GRID_COLUMN_XML, null, header, reqData, dispatch).then((res) => {
      if (res.data.out_parameters.out_ret_code > 0) {
        dispatch(
          setNewMessage({
            message: res.data.out_parameters.out_error_msg,
            type: "Error",
            show: true,
          })
        );
        setLoadingState(true);
        setAPICallingState(true);
        errStatusHandler(res, history, dispatch);
      } else {
        const columData = GridColumnDataMapper(res.data.out_parameters.out_columns_xml, "field_proceed");
        let columnFilterData = [...columData];
        if (checked) {
          columnFilterData.map((cItem) => {
            if (cItem.field === "is_published") {
              cItem.show = false;
            }
            if (cItem.field === "is_active") {
              cItem.show = true;
            }
            return 0;
          });
        } else {
          columnFilterData.map((cItem) => {
            if (cItem.field === "is_published") {
              cItem.show = true;
            }
            if (cItem.field === "is_active") {
              cItem.show = false;
            }
            return 0;
          });
        }
        setColumns([...columnFilterData]);
        setLoadingStateSearch({ ...loading, isUpdateColumn: false });
      }
    });
  };

  const exportResultData = (reqData) => {
    POSTAPI(false, EXPORT_RESULT_MODULE, null, header, reqData, dispatch).then((res) => {
      if (res.data.out_parameters.out_ret_code > 0) {
        dispatch(
          setNewMessage({
            message: res.data.out_parameters.out_error_msg,
            type: "Error",
            show: true,
          })
        );
        setLoadingState(true);
        setAPICallingState(true);
        setLoadingStateSearch({ ...loading, updateColumn: false });
        errStatusHandler(res, history, dispatch);
      } else {
        setLoadingStateSearch({ ...loading, updateColumn: false });
        downloadURI(res.data.fileName, res.data.fileLink);
      }
    });
  };

  const DeleteResultData = (reqData) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, DELETE_RESULTS, null, header, reqData, dispatch).then((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          setLoadingState(true);
          setAPICallingState(true);
          setLoadingStateSearch({ ...loading, updateColumn: false });
          errStatusHandler(res, history, dispatch);
          resolve(false);
        } else {
          resolve(true);
        }
      });
    });
  };

  const getAllDropdownData = (reqData) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, SELECT_COMBINED_RESULT_DROPDOWN, null, header, reqData, dispatch).then((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          setLoadingState(true);
          setAPICallingState(true);
          setLoadingStateSearch({ ...loading, updateColumn: false });
          errStatusHandler(res, history, dispatch);
          resolve(false);
        } else {
          resolve(res.data.row_result);
        }
      });
    });
  };

  const getDeleteFilterData = (listData, apiName) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, apiName, null, header, listData, dispatch).then((res) => {
        if (res) {
          const outParams = res.data.out_parameters;
          if (outParams.out_ret_code > 0) {
            setResultFilterLoadingState(true);
            setResultFilterAPICallingState(false);
            errStatusHandler(res, history, dispatch);
            setLoadingStateSearch({ ...loading, isSearchLoader: false });
            setResultFilterNoDataFound(false);
            setResultFilterData([]);
            setResultFilterDataCount(outParams.out_total_rows || 0);
            setResultFilterOriginalData([]);
            setResultFilteraliasData([]);
            resolve({
              status: true,
              data: [],
            });
          } else {
            if (res.data) {
              setResultFilterAPICallingState(false);
              setResultFilterLoadingState(true);
              const finalData = ResultGridDataMapper(outParams.out_results_xml);
              const finalDatawithAlias = ResultGridDataMapper(outParams.out_results_xml, "alias");
              if (finalData && finalData.length > 0) {
                let filterDateArray = [];
                for (const resultData of finalData) {
                  if (resultData && resultData.payment_date) {
                    resultData.payment_date = new Date(resultData.payment_date);
                  }
                  if (resultData && resultData.incentive_date) {
                    resultData.incentive_date = new Date(resultData.incentive_date);
                  }
                  if (resultData && resultData.action_date) {
                    resultData.action_date = new Date(resultData.action_date);
                  }
                  resultData.sortOrder = "asc";
                  filterDateArray.push(resultData);
                }

                setResultFilterData(filterDateArray);
                setResultFilterNoDataFound(false);
                setResultFilterDataCount(outParams.out_total_rows);
                setResultFilterIsColumnMenuSearch(false);
                setResultFilteraliasData(finalDatawithAlias[0]);
                setResultFilterOriginalData(filterDateArray);
                setResultFilterLoadingStateSearch({ ...loading, isResultFilterSearchLoader: false });
                outParams?.out_sys_timezone && setSysConfigTimezone(outParams?.out_sys_timezone);
                resolve({
                  status: true,
                  data: filterDateArray,
                });
              } else {
                resolve({
                  status: true,
                  data: [],
                });
              }
            } else {
              resolve({
                status: true,
                data: [],
              });
            }
          }
        }
      });
    });
  };

  return [
    {
      // Result Filter State and Setters
      resultFilterData,
      setResultFilterData,
      resultFilterDataCount,
      setResultFilterDataCount,
      resultFilterIsColumnMenuSearch,
      setResultFilterIsColumnMenuSearch,
      resultFilterNoDataFound,
      setResultFilterNoDataFound,
      resultFilterAPICalling,
      setResultFilterAPICallingState,
      resultFilterPaginationData,
      setResultFilterPaginationData,
      resultFilterPageData,
      setResultFilterPage,
      resultFilterPageSize,
      setResultFilterPageSize,
      resultFilterEditData,
      setResultFilterEditData,
      originalFilterData,
      resultFilteraliasData,
      resultFilterLoading,
      setResultFilterLoadingState,
      resultFilterLoadingState,
      setConfirmationPopup,
      confirmationPopup,
      sysConfigTimezone,
      setLoadingStateSearch,
      loading,
      columns,
      isAPICalling,
      initialLoading,
    },
    {
      getColumListXML,
      exportResultData,
      DeleteResultData,
      getDeleteFilterData,
      getAllDropdownData,
    },
  ];
}
